let defaultHint = '';
let lastTotalCount = 0;
let cartAction = '';
let excludeDiscountedProducts = false;
let excludeDiscountedCategories = false;
let excludedItemQuantityIncreased = false;
if (quantityDiscountCart) {
  excludeDiscountedProducts = quantityDiscountCart.getAttribute('data-exclude-discounted-products') === 'true';
  excludeDiscountedCategories = quantityDiscountCart.getAttribute('data-exclude-categories') === 'true';
  defaultHint = document.querySelector('.ed-quantity-discount-cart [data-default-subtitle]').textContent;
}

$(document).on('cart.ready', function (event, cart) {
  let totalCount = cart.item_count;

  if (quantityDiscountCart) {
    lastTotalCount = cart.item_count;

    if (excludeDiscountedProducts || excludeDiscountedCategories) {
      markExcludedProductsFromQuantityDiscount();
      const totalCountMinusExcluded = calculateTotalCountMinusExcluded();
      updateQuantityDiscountProgressBar(totalCountMinusExcluded);
    } else {
      updateQuantityDiscountProgressBar(totalCount);
    }
  }
});

$(document).on('cart.requestComplete', function (event, cart) {
  let totalCount = cart.item_count;

  if (quantityDiscountCart) {
    if (totalCount > lastTotalCount) {
      cartAction = 'add';
    } else if (totalCount < lastTotalCount) {
      cartAction = 'remove';
    }
    lastTotalCount = totalCount;

    // Detect if added items are excluded and set a flag
    excludedItemQuantityIncreased = cart.items_added?.some(item => {
      const itemElement = document.querySelector(`.cart__product[data-id="${item.product_id}"]`);
      return itemElement && (
        (excludeDiscountedProducts && itemElement.getAttribute('data-quantity-discount-product-excluded') === 'true') ||
        (excludeDiscountedCategories && itemElement.getAttribute('data-quantity-discount-category-excluded') === 'true')
      );
    }) || cart.items_removed?.some(item => {
      const itemElement = document.querySelector(`.cart__product[data-id="${item.product_id}"]`);
      return itemElement && (
        (excludeDiscountedProducts && itemElement.getAttribute('data-quantity-discount-product-excluded') === 'true') ||
        (excludeDiscountedCategories && itemElement.getAttribute('data-quantity-discount-category-excluded') === 'true')
      );
    });

    if (excludeDiscountedProducts || excludeDiscountedCategories) {
      markExcludedProductsFromQuantityDiscount();
      const totalCountMinusExcluded = calculateTotalCountMinusExcluded();
      updateQuantityDiscountProgressBar(totalCountMinusExcluded);
    } else {
      updateQuantityDiscountProgressBar(totalCount);
    }
  }
});

function updateQuantityDiscountProgressBar(count) {
  const progressBar = document.querySelector('.ed-quantity-discount-cart .progress-bar .progress');
  const milestones = document.querySelectorAll('.ed-quantity-discount-cart .milestone');
  const subtitle = document.querySelector('.ed-quantity-discount-cart .subtitle');

  milestones.forEach(milestone => milestone.classList.remove('ed-animation-circle'));

  const milestoneValues = Array.from(milestones).map(milestone => {
    if (milestone.dataset.milestoneOne) return parseInt(milestone.dataset.milestoneOne, 10);
    if (milestone.dataset.milestoneTwo) return parseInt(milestone.dataset.milestoneTwo, 10);
    if (milestone.dataset.milestoneThree) return parseInt(milestone.dataset.milestoneThree, 10);
    if (milestone.dataset.milestoneFour) return parseInt(milestone.dataset.milestoneFour, 10);
    if (milestone.dataset.milestoneFive) return parseInt(milestone.dataset.milestoneFive, 10);
  });

  const filteredMilestoneValues = milestoneValues.filter(value => !isNaN(value));
  let activeHint = defaultHint;
  let isAnyMilestoneReached = false;
  let missingAmount = 1;
  let lastMilestoneReachedIndex = null;

  // Update active class for milestones based on current count
  milestones.forEach((milestone, index) => {
    const milestoneValue = filteredMilestoneValues[index];
    const hintAttribute = `milestone-${index + 1}Hint`;

    if (count >= milestoneValue) {
      milestone.classList.add('active-milestone');
      isAnyMilestoneReached = true;
      lastMilestoneReachedIndex = index; // Track the last reached milestone index

      if (milestone.dataset[hintAttribute]) {
        activeHint = milestone.dataset[hintAttribute];
      }
    } else {
      milestone.classList.remove('active-milestone');
    }
  });

  // If there is a last reached milestone, add the animation class to it
  if (lastMilestoneReachedIndex !== null) {
    milestones[lastMilestoneReachedIndex].classList.add('ed-animation-circle');
  }

  applyAnimationCircle(milestones, count, filteredMilestoneValues);

  // Determine the missing amount for the next milestone
  for (let i = 0; i < filteredMilestoneValues.length; i++) {
    if (count < filteredMilestoneValues[i]) {
      missingAmount = filteredMilestoneValues[i] - count;
      break;
    }
  }

  if (!isAnyMilestoneReached) {
    if (count === 0) {
      subtitle.textContent = defaultHint;
    } else {
      if (missingAmount === 1) {
        subtitle.textContent = `Füge ein Tattoo für kostenlosen Versand hinzu`
      } else {
        subtitle.textContent = `Füge ${missingAmount} Tattoos für kostenlosen Versand hinzu`
      }
    }
  } else if (activeHint) {
    let replacementText = missingAmount > 1 ? `${missingAmount} Tattoos` : `ein Tattoo`;
    subtitle.textContent = activeHint.replace('((missing_amount))', replacementText);
  }

  let progressWidth = 0;
  if (count >= filteredMilestoneValues[filteredMilestoneValues.length - 1]) {
    progressWidth = 100;
  } else {
    for (let i = 0; i < filteredMilestoneValues.length - 1; i++) {
      if (count === filteredMilestoneValues[i]) {
        // If the count matches a milestone, fill up to that milestone.
        progressWidth = (i / (filteredMilestoneValues.length - 1)) * 100;
        break;
      } else if (count > filteredMilestoneValues[i] && count < filteredMilestoneValues[i + 1]) {
        // If the count is in between milestones, fill up to the last milestone.
        progressWidth = (i / (filteredMilestoneValues.length - 1)) * 100;
        break;
      }
    }
  }

  progressBar.style.width = `${progressWidth}%`;
}

function applyAnimationCircle(milestones, count, filteredMilestoneValues) {
  let inBetweenMilestones = false;
  for (let i = 0; i < filteredMilestoneValues.length - 1; i++) {
    if (count > filteredMilestoneValues[i] && count < filteredMilestoneValues[i + 1]) {
      inBetweenMilestones = true;
    }
  }

  if (count > filteredMilestoneValues[filteredMilestoneValues.length - 1] || cartAction === 'remove' || inBetweenMilestones || excludedItemQuantityIncreased) {
    return;
  }

  milestones.forEach(milestone => {
    if (milestone.classList.contains('ed-animation-circle')) {
      const animationContainer = milestone.querySelector('.animation-circle-container-discount-bar');
      if (animationContainer) {
        const animationCircle = document.createElement('div');
        animationCircle.className = 'animation-circle-discount-bar';
        animationContainer.appendChild(animationCircle);

        setTimeout(() => {
          animationCircle.remove();
        }, 350); // Match the animation duration
      }
    }
  });
}

function markExcludedProductsFromQuantityDiscount() {
  const excludedProductIds = document.querySelector('.ed-quantity-discount-excluded-products[data-excluded-product-ids]')
    .getAttribute('data-excluded-product-ids')
    .split(',')
    .filter(id => id.trim() !== '');
  const excludedCategoryIds = document.querySelector('.ed-quantity-discount-excluded-products[data-excluded-category-ids]')
    .getAttribute('data-excluded-category-ids')
    .split(',')
    .filter(id => id.trim() !== '');
  const items = document.querySelectorAll('.cart__product');

  items.forEach(item => {
    const itemId = item.getAttribute('data-id');

    item.removeAttribute('data-quantity-discount-product-excluded');
    item.removeAttribute('data-quantity-discount-category-excluded');

    if (excludedProductIds.includes(itemId)) {
      item.setAttribute('data-quantity-discount-product-excluded', 'true');
    }

    if (excludedCategoryIds.includes(itemId)) {
      item.setAttribute('data-quantity-discount-category-excluded', 'true');
    }

    const matchedProductAttribute = document.querySelector(`[data-quantity-discount-excluded-pid-product="${itemId}"]`);
    const matchedCategoryAttribute = document.querySelector(`[data-quantity-discount-excluded-pid-category="${itemId}"]`);

    if (matchedProductAttribute) {
      item.setAttribute('data-quantity-discount-product-excluded', 'true');
    }

    if (matchedCategoryAttribute) {
      item.setAttribute('data-quantity-discount-category-excluded', 'true');
    }
  });
}

function calculateTotalCountMinusExcluded() {
  const cartItems = document.querySelectorAll('.cart__product');
  let totalCountMinusExcluded = 0;

  cartItems.forEach(item => {
    const isProductExcluded = item.getAttribute('data-quantity-discount-product-excluded') === 'true';
    const isCategoryExcluded = item.getAttribute('data-quantity-discount-category-excluded') === 'true';
    // Find the quantity element within this item and parse its number
    const quantityElement = item.querySelector('.cart__quantity');
    const quantity = quantityElement ? parseInt(quantityElement.textContent, 10) : 1;

    if (excludeDiscountedProducts && excludeDiscountedCategories) {
      if (!isProductExcluded && !isCategoryExcluded) {
        totalCountMinusExcluded += quantity;
      }
    } else if (excludeDiscountedProducts && !isProductExcluded) {
      totalCountMinusExcluded += quantity;
    } else if (excludeDiscountedCategories && !isCategoryExcluded) {
      totalCountMinusExcluded += quantity;
    }
  });

  return totalCountMinusExcluded;
}